import { IFunctionComponent } from '@omaze/app';
import { COLLAPSE_SIZES, COLLAPSE_STYLES, OzCollapse } from '@omaze/omaze-ui';
import React, { ReactElement } from 'react';

import { IAdditionalWinner } from '../../../../../../../ClosedExperienceModule/ClosedExperience.state';
import { winnerFeatureNamespace } from '../../../../../WinnerFeature.namespace';

import { ADDITIONAL_WINNERS_QA, displayName } from './AdditionalWinners.qa';
import {
    AdditionalWinnersPresenter,
    IAdditionalWinnersClassNames,
} from './AdditionalWinnersPresenter/AdditionalWinnersPresenter';

export interface IAdditionalWinnersProps {
    additionalWinners: IAdditionalWinner[];
}

export const AdditionalWinners: IFunctionComponent<IAdditionalWinnersProps> = winnerFeatureNamespace.createComponent(
    displayName,
    (props: IAdditionalWinnersProps): ReactElement => {
        const { additionalWinners }: IAdditionalWinnersProps = props;
        const presenter: AdditionalWinnersPresenter = new AdditionalWinnersPresenter(additionalWinners);

        const {
            container,
            title,
            lineBreak,
        }: IAdditionalWinnersClassNames = presenter.getAllClassNames();

        return (
            <div className={container} data-testid={ADDITIONAL_WINNERS_QA.CONTAINER}>
                <OzCollapse
                    size={COLLAPSE_SIZES.SMALL}
                    style={COLLAPSE_STYLES.TEXT}
                >
                    <OzCollapse.Title>
                        <span className={title} data-testid={ADDITIONAL_WINNERS_QA.BUTTON_TEXT}>
                            {presenter.getTitle()}
                        </span>
                    </OzCollapse.Title>
                    <OzCollapse.Content>
                        <div className={lineBreak} data-testid={ADDITIONAL_WINNERS_QA.CONTENT} />
                        {
                            additionalWinners.map((_: IAdditionalWinner, index: number): ReactElement => {
                                return (
                                    <div
                                        key={index}
                                        className={presenter.getAdditionalWinnerClassNames(index)}
                                    >
                                        {presenter.getAdditionalWinnerText(index)}
                                    </div>
                                );
                            })
                        }
                    </OzCollapse.Content>
                </OzCollapse>
            </div>
        );
    }
);
